<div>
    <app-skiplinks></app-skiplinks>
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer *ngIf="toggle_feature_hubgrade"></app-footer>
</div>
